import { useParams } from "react-router-dom"
import { Container, Row, Col } from "react-bootstrap"
import { useGetKeyValueByIdQuery } from "../../../services/bClientApi"
import KeyValueEntry from "../../../Components/KeyValue/KeyValueEntry/KeyValueEntry"

export default function KeyValuePage() {
    const { keyValueId = '' } = useParams()

    const {
        data,
        error,
        isLoading
    } = useGetKeyValueByIdQuery(keyValueId, { skip: !keyValueId })
    const keyValueData = data || {}

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Key Value Details</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    {keyValueId && keyValueData && keyValueData._id && !isLoading && (
                        <KeyValueEntry
                            keyValueData={keyValueData}
                            fullView={true}
                        />
                    )}
                </Col>
            </Row>
        </Container>
    )
}